import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import HelpCenterSettingsWidgetConfigurationInstallAppQuery from '@atlassian/jira-relay/src/__generated__/HelpCenterSettingsWidgetConfigurationInstallAppQuery.graphql';

export const installEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-widget-configuration-install-app" */ './src/ui/HelpCenterSettingsWidgetConfigurationInstallApp.tsx'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				page: {
					parameters: HelpCenterSettingsWidgetConfigurationInstallAppQuery,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
